"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionCard = exports.PositionMapObject = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const PositionPointCard_1 = require("./PositionPointCard");
const PositionPolygonCard_1 = require("./PositionPolygonCard");
var PositionMapObject;
(function (PositionMapObject) {
    PositionMapObject["LAMP"] = "lampa";
    PositionMapObject["SWITCH_POINT"] = "zb";
})(PositionMapObject || (exports.PositionMapObject = PositionMapObject = {}));
//TODO refactor this component
//TODO add delete position button
const PositionCard = ({ mode: modeOriginal, version, objectType = "point", title, name }) => {
    return objectType !== "point" ? ((0, jsx_runtime_1.jsx)(PositionPolygonCard_1.PositionPolygonCard, { version: version, mode: modeOriginal, objectType: objectType, title: title, name: name })) : ((0, jsx_runtime_1.jsx)(PositionPointCard_1.PositionPointCard, { version: version, mode: modeOriginal, title: title }));
};
exports.PositionCard = PositionCard;
